import { useState } from 'react';
import { fmtCurrency } from '@/shared/utils/formatCurrency';

export default function BudgetSuggestionsBanner({ suggestions, saveBudget, currency, theme: t }) {
  const [open, setOpen] = useState(true);
  const [applied, setApplied] = useState({});

  if (!suggestions || suggestions.length === 0) return null;

  const pending = suggestions.filter(s => !applied[s.category]);
  if (pending.length === 0) return null;

  function handleApply(s) {
    saveBudget(s.category, s.suggestedBudget);
    setApplied(prev => ({ ...prev, [s.category]: true }));
  }

  return (
    <div style={{
      background: t.cardBg,
      border: '1px solid ' + t.cardBorder,
      borderRadius: 14,
      padding: 16,
      marginBottom: 16,
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          padding: 0,
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 700, color: t.text }}>
          {'💡 Budget suggestions (' + pending.length + ')'}
        </span>
        <span style={{ fontSize: 12, color: t.textMuted }}>{open ? '▲ Hide' : '▼ Show'}</span>
      </button>

      {open && (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <p style={{ margin: 0, fontSize: 12, color: t.textMuted, lineHeight: 1.5 }}>
            Based on your last 3 months of spending:
          </p>
          {pending.map(s => (
            <div
              key={s.category}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 12,
                padding: '10px 12px',
                background: s.type === 'raise' ? 'rgba(245,158,11,0.07)' : 'rgba(22,163,74,0.07)',
                borderRadius: 10,
                border: '1px solid ' + (s.type === 'raise' ? 'rgba(245,158,11,0.25)' : 'rgba(22,163,74,0.25)'),
                flexWrap: 'wrap',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: t.text }}>{s.icon + ' ' + s.category}</div>
                <div style={{ fontSize: 11, color: t.textMuted, marginTop: 2 }}>
                  {'Current: ' + fmtCurrency(s.currentBudget, currency) +
                    ' · 3-mo avg: ' + fmtCurrency(s.avg3mo, currency) +
                    ' · Suggested: ' + fmtCurrency(s.suggestedBudget, currency)}
                </div>
              </div>
              <button
                onClick={() => handleApply(s)}
                style={{
                  background: s.type === 'raise' ? '#f59e0b' : '#16a34a',
                  color: 'white',
                  border: 'none',
                  borderRadius: 8,
                  padding: '6px 14px',
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                {'Apply ' + fmtCurrency(s.suggestedBudget, currency)}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
